export default "__VITE_PUBLIC_ASSET__a29fc08c__"